import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { FieldSet } from '@sigeco/tools';

import makeStyles from '@material-ui/core/styles/makeStyles';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import CardContent from '@material-ui/core/CardContent';
import Icon from '@material-ui/core/Icon';

const useStyles = makeStyles(() => ({
    content: {
        padding: '0.5rem 0.75rem 0.75rem'
    },
    root: {
        flex: '0 0 auto',
        marginBottom: '0.75rem',
        '@media (min-width: 1401px)': {
            marginBottom: '1rem',
        }
    },
    mime: {
        fontSize: 8,
        "& .MuiFormLabel-root": {
          color: "red"
        }
      }
}));

//const URL = 'https://perlube.com/ini/gigantes-presupuesto.json'

const ResumenPresupuesto2022 = () => {
  
    const classes = useStyles();

    const store = useSelector(state => state.resumen.store);
    const filters = useSelector(state => state.resumen.filters);

    const [data, setData] = useState([])
    const [presup, setPresup] = useState([]);

    useEffect(() => {
       
            setData(store.presupuesto);
            setPresup(store.clinuevnueve); 
   
        
    }, [store.clinuevnueve, store.presupuesto])
    //}, [data.presupuesto, store.clinuevnueve, store.presupuesto, store.presupuesto2])


    const renderHeader = () => {
        let headerElement = ['Nro','Distribuidor', '  Canal  ','Asesor', 'Cumplimiento', 'Pago']

        return headerElement.map((key, index) => {
            return <th key={index} style={{ backgroundColor: 'lightsteelblue'  }}>{key.toUpperCase()} </th>
        })
    }

    
    const renderBody = (employees) => {
        var i = 1;
        return employees && employees.map(({ id, distribuidor, tipo, asesor, cumplimiento, pago }) => {
            return (
                <tr style={{ fontSize: '12px',backgroundColor: i%2 === 0 ?'lavender' : 'white' }} key={i}>
                    <td>{i++ }</td>
                    <td>{distribuidor}</td>
                    <td>{tipo}</td>
                    <td>{asesor}</td>
                    <td style={{textAlign : 'center'}}>{cumplimiento.toFixed(2)}%</td>
                    <td style={{textAlign : 'center'}}><b>${pago}</b></td>
                </tr>
            )
        })
    }

    return (
        <div className={classes.root}  style={{   textAlign : 'center'}} > 
        
           
           <FieldSet iconCls="fas fa-hand-pointer" title="CUMPLIMIENTO PRESUPUESTO " defaultExpanded={true}   expandable>
                   
                   <CardContent style={{ overflow:'hidden' }}>

                           <ListItem   >
                               <ListItemAvatar>
                                 <Avatar>
                                 <Icon className="fas  fa-hand-pointer" ></Icon>
                                 </Avatar>
                               </ListItemAvatar>
                           </ListItem>
                           <ListItemText primary="Activo" secondary= {store.meses[filters.desde.getMonth()] +',  '+ filters.desde.getFullYear()}/> 
                    </CardContent>

                    <div  style={{ flex: 1,   justifyContent: "center",   backgroundColor: "#e5e5e5" }}>
                            -
                        </div>

                        <div style={{display: 'block',  width: '100%', border: '5px', 
                            padding: '10px', justifyContent: "center",}}>
    
                            <FieldSet iconCls="fas fa-hand-pointer" title="Info" 
                            defaultExpanded expandable  style={{ textAlign : 'center', width: '200%'}} > 
                
                                <div  style={{ flex: 1,   justifyContent: "center"}}>
                                        <img alt='logo'  src={ './images/resumen2022.png'}/>
 
                                        <div  style={{ flex: 1,   justifyContent: "center"}}>
                                        
                                        <CardContent  style={{ border : '36px'}}>              
                                        <table id='employee'  style={{ display: 'inline-block', border: "10px solid rgba(224, 224, 224, 1)", borderRadius:'5px'}}>
                                                <thead>
                                                    <tr>{renderHeader()}</tr>
                                                </thead>
                                                <tbody>
                                                    {renderBody(data)}
                                                </tbody>
                                        </table>

                                        <br></br>       
                                        <p></p>         
                                                <table id='employee'  style={{ display: 'inline-block', border: "10px solid rgba(183, 193, 201, 1)", borderRadius:'5px'}}>
                                                        <thead>
                                                            <tr>{renderHeader()}</tr>
                                                        </thead>
                                                        <tbody>
                                                            {renderBody(presup)}
                                                        </tbody>
                                                </table>
                                        </CardContent>
                                       
                                        </div>
                                </div>
                            </FieldSet>  
                        </div>      
                    
            </FieldSet>   
     
        </div>
    )
};

export default ResumenPresupuesto2022;